/* Package JSON Import will be here */
import ReactGA from 'react-ga4';
/* Package JSON Import will be here */

/* Project Import will be here */
import { forEach } from 'lodash';
import Constants from 'utilities/appConstants';
/* Project Import will be here */

/* Set UserId to GA */
export const GASetUserId = (userId) => {
    const hostName = window.location.hostname;
    const hostNameSplitArray = hostName.split(".");

    ReactGA.set({ userId: `${hostNameSplitArray[0]}-${userId}` });
};

/* GA begin checkout event */
export const GABeginCheckout = (cart) => {
    const beginCheckoutParams = {
        currency: window.GACurrency,
        items: getCartProducts(cart)
    };

    ReactGA.event(Constants.GA_EVENTS_BEGIN_CHECKOUT, beginCheckoutParams);
};

/* GA view cart event */
export const GAViewCart = (cart) => {
    const viewCartParams = {
        currency: window.GACurrency,
        items: getCartProducts(cart)
    };

    ReactGA.event(Constants.GA_EVENTS_VIEW_CART, viewCartParams);
};

const getCartProducts = (cart) => {
    const cartProductList = [];
    for (let key in cart.data) {
        const cartProduct = cart.data[key];

        if (cartProduct.ConversionQty && !cartProduct.IsFree) {
            cartProductList.push({
                item_id: cartProduct.ProductId,
                quantity: cartProduct.Qty,
                item_name: cartProduct.ProductName
            });
        }
    }
    return cartProductList;
}

/* GA view product item */
export const GAViewItem = (productItem) => {
    const viewCartItemParams = {
        currency: window.GACurrency,
        items: [{
            item_id: productItem.ProductId,
            item_name: productItem.ProductName
        }]
    };

    ReactGA.event(Constants.GA_EVENTS_VIEW_ITEM, viewCartItemParams);
};

/* GA push notification event */
export const GAPushNotification = (notificationType) => {
    const notificationParams = {
        push_notification_type: notificationType
    };

    ReactGA.event(Constants.GA_EVENTS_PUSH_NOTIFICATION, notificationParams);
};

/* GA login event */
export const GALogin = (mobile) => {
    const loginParams = {
        retailer_mobile: mobile
    };

    ReactGA.event(Constants.GA_EVENTS_LOGIN, loginParams);
};

/* GA logout event */
export const GALogout = (mobile) => {
    const logoutParams = {
        retailer_mobile: mobile
    };

    ReactGA.event(Constants.GA_EVENTS_LOGOUT, logoutParams);
};

/* GA page view event */
export const GAPageView = (pageTitle, pagePath) => {
    const pageViewParams = {
        page_title: pageTitle,
        page_path: pagePath
    };

    ReactGA.event(Constants.GA_EVENTS_PAGE_VIEW, pageViewParams);
};

/* GA page view event */
export const GATabChange = (tabName) => {
    ReactGA.event(Constants.GA_EVENTS_TAB_CHANGE, { tab_name: tabName });
};

/* GA search content  */
export const GASearch = (searchText) => {
    ReactGA.event(Constants.GA_EVENTS_SEARCH, { search_term: searchText });
};

/* GA voice search initiation event */
export const GAVoiceSearchInitiation = () => {
    ReactGA.event(Constants.GA_EVENTS_VOICE_SEARCH_INITIATION);
};

/* GA barcode search initiation event */
export const GABarCodeSearchInitiation = () => {
    ReactGA.event(Constants.GA_EVENTS_BARCODE_SEARCH_INITIATION);
};

/* GA show more button event */
export const GAShowMoreButton = (pageType) => {
    const shoeMoreButtonParam = {
        page_type: pageType
    };

    ReactGA.event(Constants.GA_EVENTS_SCROLL_SHOW_MORE_BUTTON, shoeMoreButtonParam);
};


/* GA Add_To_Cart product event */
export const GAAddToCart = (productList) => {
    const addToCartProductList = [];
    forEach(productList, (item) => {
        addToCartProductList.push({
            item_id: item.PId,
            item_name: item.PName,
            currency: window.GACurrency,
            quantity: item.Qty
        });
    });

    ReactGA.event(Constants.GA_EVENTS_ADD_TO_CART, { items: addToCartProductList });
};

/* GA add to favourite event */
export const GAAddToWishlist = (favouriteInfo) => {
    const addToFavProductList = {
        items: [{
            item_id: favouriteInfo.ProductId,
            item_name: favouriteInfo.ProductName
        }]
    };

    ReactGA.event(Constants.GA_EVENTS_ADD_TO_WISHLIST, addToFavProductList);
};

/* GA - Track remove from favourite event */
export const GARemoveFromWishlist = (product) => {
    const removeFromFavParam = {
        item_id: product.ProductId,
        item_name: product.ProductName
    };

    ReactGA.event(Constants.GA_EVENTS_REMOVE_FROM_WISHLIST, removeFromFavParam);
};

/* GA scheme details popup open event  */
export const GAViewPromotion = (schemeDetail) => {
    const schemeDetailParams = {
        promotion_id: schemeDetail.Scheme[0].Id,
        promotion_name: schemeDetail.Scheme[0].Desc
    };

    ReactGA.event(Constants.GA_EVENTS_VIEW_PROMOTION_DETAILS, schemeDetailParams)
}

/* GA for register product complaint  */
export const GAProductComplaint = (productItem, skuName) => {
    const complaintParams = {
        product_id: productItem.productId,
        product_name: skuName,
        complaint_reason_id: productItem.complaintReasonId
    };

    ReactGA.event(Constants.GA_EVENTS_PRODUCT_COMPLAINT, complaintParams)
}

/* GA for product history search  */
export const GAHistorySearch = (pageType, searchQuery) => {
    const historySearchParams = {
        page_type: pageType,
        search_text: searchQuery.searchText,
        start_date: searchQuery.sDate,
        end_date: searchQuery.eDate,
        month_value: searchQuery.monthValue
    };

    ReactGA.event(Constants.GA_EVENTS_PRODUCT_HISTORY_SEARCH, historySearchParams)
}

/* GA for smart list delete event  */
export const GASmartListDelete = (smartListId, smartListName) => {
    const smartListDeleteParams = {
        smart_list_id: smartListId,
        smart_list_name: smartListName
    };

    ReactGA.event(Constants.GA_EVENTS_SMART_LIST_DELETE, smartListDeleteParams)
}

/* GA - Track add smart list event  */
export const GAAddToSmartList = (smartListName) => {
    const addToSmartListParams = {
        smart_list_name: smartListName
    };

    ReactGA.event(Constants.GA_EVENTS_ADD_TO_SMART_LIST, addToSmartListParams)
}

/* GA - Track cancel order event  */
export const GACancelOrder = (orderNo) => {
    const cancelOrderParams = {
        order_number: orderNo
    };

    ReactGA.event(Constants.GA_EVENTS_CANCEL_ORDER, cancelOrderParams)
}

/* GA - Track filter apply event  */
export const GAFilterApply = (pageType, sortingType) => {
    const filterApplyParams = {
        page_type: pageType,
        sorting_type: sortingType
    };

    ReactGA.event(Constants.GA_EVENTS_FILTER_APPLY, filterApplyParams)
}

/* GA - Track menu drawer initiation  */
export const GAMenuDrawer = () => {
    ReactGA.event(Constants.GA_EVENTS_MENU_DRAWER)
}

/* GA for remove from cart details  */
export const GARemoveFromCart = (isFromClearCart, cart, productList) => {
    const removeCartParams = {
        items: isFromClearCart ? getCartProducts(cart) : productList
    };

    ReactGA.event(Constants.GA_EVENTS_REMOVE_FROM_CART, removeCartParams)
}

/* GA - Track remove sales return summary event */
export const GARemoveFromSalesReturnSummary = (products) => {
    forEach(products, (item) => {
        const removeFromSalesReturnSummaryParams = {
            item_id: item.ProductId === undefined ? item.PId : item.ProductId,
            item_name: item.ProductName === undefined ? item.PName : item.ProductName
        };

        ReactGA.event(Constants.GA_EVENTS_REMOVE_FROM_SALES_RETURN_SUMMARY, removeFromSalesReturnSummaryParams);
    });
};

/* GA - Track submitted sales return summary SRH Number details */
export const GASubmitSalesReturnSummary = (salesReturnOrderId) => {
    ReactGA.event(Constants.GA_EVENTS_SUBMIT_SALES_RETURN_SUMMARY, { sales_return_order_number: salesReturnOrderId });
};

/* Add the GA transaction after the successful place order  */
export const GAAddTransaction = (orderSummary, productList, user) => {
    let productItems = [];
    forEach(productList, (item) => {
        productItems.push({
            item_id: item.ProductId,
            item_name: item.ProductName,
            currency: window.GACurrency,
            quantity: item.Qty
        });
    });

    const purchaseEventParams = {
        transaction_id: orderSummary.OrderNo,
        affiliation: user.retailername,
        currency: window.GACurrency,
        value: orderSummary.TotalAmount,
        shipping: 0,
        items: productItems
    };

    ReactGA.event(Constants.GA_EVENTS_PURCHASE, purchaseEventParams);
}
/* GA - Track notification read event  */
export const GANotificationRead = (notificationItem) => {
    const notificationReadParams = {
        notification_id: notificationItem.Id,
        notification_message: notificationItem.Desc,
        notification_date: notificationItem.CreatedOn
    };

    ReactGA.event(Constants.GA_EVENTS_NOTIFICATION_READ, notificationReadParams)
}

/* GA - Track support helpline mobile or email event */
export const GASupportHelpline = (key, value) => {
    const supportHelplineParams = {
        support_helpline_key: key,
        support_helpline_value: value,
    };

    ReactGA.event(Constants.GA_EVENTS_SUPPORT_HELPLINE, supportHelplineParams);
};

/* GA - Track showOrderSummary  event  */
export const GAShowOrderSummary = () => {
    ReactGA.event(Constants.GA_EVENTS_SHOW_ORDER_SUMMARY);
}

/* GA - Track Delivery Address Change  event  */
export const GADeliveryAddressChange = () => {
    ReactGA.event(Constants.GA_EVENTS_DELIVERY_ADDRESS_CHANGE);
}

/* GA - Track my rewards filter event */
export const GAMyRewardsFilter = (key) => {
    const myRewardsFilterParams = {
        my_rewards_key: key
    };

    ReactGA.event(Constants.GA_MY_REWARDS_FILTER, myRewardsFilterParams);
};

/* GA - Track my rewards redeem event */
export const GAMyRewardsRedeem = (key) => {   
    const myRewardsRedeemParams = {
        redeem_Product_key : key
    };
    ReactGA.event(Constants.GA_MY_REWARDS_REDEEM, myRewardsRedeemParams);

};

/* GA - Track settings - change mobile number event */
export const GAChangeMobileNumber = (key) => {
    const changeMobileNumberParams = {
        changed_mobile_number: key
    };

    ReactGA.event(Constants.GA_CHANGE_MOBILE_NUMBER, changeMobileNumberParams);
};
